import { GLOBAL_POPULATION_FIELDS } from './globalFields'

// Adopting the existing contact starts from their saved record and lays what
// the manager typed on top: a field they filled in wins, a field they left
// alone keeps what the contact already had. Same rule the file import follows
// when it updates someone.
const typedWins = (typed: any, existing: any) =>
  typed !== undefined && typed !== null && typed !== '' ? typed : existing

// A list the manager did not touch is left as the contact had it; one they put
// something in replaces it, so they can see what they are about to save.
const typedListWins = (typed: any[], existing: any[]) =>
  typed && typed.length ? typed : (existing ?? [])

export const mergeTypedOverExisting = (existing: any, typed: any, id: number, globalFieldsLocked: boolean) => {
  const population: any = { ...existing.population }
  Object.keys(typed.population).forEach(key => {
    population[key] = typedWins(typed.population[key], existing.population?.[key])
  })
  population.userTypes = typedListWins(typed.population.userTypes, existing.population?.userTypes)

  // The adopted contact's home community is not this one, so a save cannot change
  // their global details - keep what they already hold rather than showing the
  // typed name in a locked field that will never take it.
  if (globalFieldsLocked) {
    GLOBAL_POPULATION_FIELDS.forEach(key => {
      population[key] = existing.population?.[key]
    })
  }

  return {
    ...existing,
    id,
    population,
    emergency: {
      ...existing.emergency,
      contacts: typedListWins(typed.emergency?.contacts, existing.emergency?.contacts),
    },
    family: {
      ...existing.family,
      household: typedWins(typed.family?.household, existing.family?.household),
      spouse: typedWins(typed.family?.spouse, existing.family?.spouse),
      children: typedListWins(typed.family?.children, existing.family?.children),
    },
    contacts: {
      ...existing.contacts,
      roles: typedListWins(typed.contacts?.roles, existing.contacts?.roles),
      tags: typedListWins(typed.contacts?.tags, existing.contacts?.tags),
    },
  }
}
